import { getAppConfig, type DeploymentEnvironment } from './environment.base'

export const DEPLOYMENT_ENVIRONMENT: DeploymentEnvironment = 'qa'
export const APP_CONFIG = getAppConfig(DEPLOYMENT_ENVIRONMENT)
